var map = {
	"./acl_favicon.png": 24609,
	"./affl_favicon.png": 47967,
	"./afp_favicon.png": 83929,
	"./demo_favicon.png": 50902,
	"./demo_favicon1.png": 55696,
	"./devpfmloc_favicon.png": 9089,
	"./dp_favicon.png": 95880,
	"./group-icons.png": 10117,
	"./isportz-logo.png": 80433,
	"./isportz_favicon.png": 11515,
	"./logo.svg": 27998,
	"./mystics_favicon.png": 62775,
	"./n2dust_favicon.png": 15811,
	"./playersway_favicon.png": 95760,
	"./pre-acl_favicon.png": 16844,
	"./pre-affl_favicon.png": 18292,
	"./pre-dp_favicon.png": 52391,
	"./pre-mystics_favicon.png": 4028,
	"./pre-playersway_favicon.png": 45933,
	"./pre-wyb_favicon.png": 61476,
	"./tctitans_favicon.png": 55773,
	"./vsva_favicon.png": 13494,
	"./wyb_favicon.png": 72387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32097;